import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["muteSwitch", "muteFormInput", "muteForm"]

  toggleMute(event) {
    console.log("OK")
    const checkbox = event.currentTarget;
    const classroomId = checkbox.dataset.id;
    let mutedClassrooms = this.muteFormInputTarget.value.split(',')

    if (checkbox.checked) {
      mutedClassrooms = mutedClassrooms.filter(id => id !== classroomId)
    } else if (!mutedClassrooms.includes(classroomId)) {
      mutedClassrooms.push(classroomId)
    }

    this.muteFormInputTarget.value = mutedClassrooms.join(',')
    this.muteFormTarget.submit()
  }
}
